import React, { useEffect, useMemo, useRef, useState } from "react";
import { Wrapper } from "../HOC";
import { Field, Formik } from "formik";
import { TextField } from "formik-mui";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { FaCloudUploadAlt } from "react-icons/fa";
import SelectInput from "../components/SelectInput";
import Spinner from "../components/Loader/Spinner";
import LoadingModal from "../components/Loader/LoadingModal";
import { ContentSchema, initialContent } from "../schemas/ContentSchema";
import { useProperty } from "../context/PropertyContext";
import { isEmpty } from "lodash";
import { ImPlay2 } from "react-icons/im";
import { toast } from "react-toastify";

const AddContent = () => {
  const { getrooms, rooms, addcontent, setValues, properties, setUploadImage, loader, done, uploadImage, uploadContent } = useProperty();
  const [room, setRoom] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const selectInputRef = useRef();
  const [previews, setPreviews] = useState([]);
  const imageRef = useRef();

  const handleInputChange = async (value) => {
    selectInputRef.current.select.clearValue();
    await getrooms(value);
    setPropertyName(value);
  };

  const propertyList = useMemo(() => {
    return properties.map((property) => property.propertyName);
  }, [properties]);

  const roomList = useMemo(() => {
    return rooms.map((room) => room.room);
  }, [rooms]);

  const handleSelectRoom = (value) => {
    setRoom(value);
  };

  const handleSubmit = async (values) => {
    if (room) {
      if (uploadImage) {
        await addcontent(false);
        setValues({ ...values, room, propertyName });
      } else {
        await uploadContent({ ...values, room, propertyName });
      }
    } else {
      toast.error("Please select a room you wish to add the content");
    }
  };
  const handleMultipleImages = (evnt) => {
    const selectedFIles = [];
    const targetFiles = evnt.target.files;
    const targetFilesObject = [...targetFiles];
    targetFilesObject.map((file) => {
      return selectedFIles.push({ file: file, url: URL.createObjectURL(file) });
    });
    setPreviews(selectedFIles);
  };

  const photos = useMemo(() => {
    if (!isEmpty(previews)) {
      return Array.from(previews).filter(
        (image) => image.file.type === "image/png" || image.file.type === "image/jpg" || image.file.type === "image/jpeg"
      );
    }
  }, [previews]);

  const videos = useMemo(() => {
    if (!isEmpty(previews)) {
      return Array.from(previews).filter(
        (image) => image.file.type === "video/mp4" || image.file.type === "video/mp3" || image.file.type === "video/mkv"
      );
    }
  }, [previews]);

  useEffect(() => {
    if (done) {
      setPreviews([]);
    }
  }, [done]);

  return (
    <Wrapper>
      {loader ? (
        <Spinner />
      ) : (
        <>
          {" "}
          <LoadingModal />
          <div className="w-full">
            <p className="text-2xl font-bold pb-2">Add New Contents</p>
            <Formik onSubmit={handleSubmit} initialValues={initialContent} validationSchema={ContentSchema}>
              {({ handleSubmit, values }) => (
                <div>
                  <>
                    <div className="flex justify-between items-start w-[100%]">
                      <div className="w-[50%]">
                        <div className="pt-6 flex justify-between items-center w-full">
                          <div className="pr-6 w-[65%]">
                            <SelectInput options={propertyList} handleChange={handleInputChange} minWidth="md:w-full" label="Select Home/Building" />
                          </div>
                          <div className="w-[35%]">
                            <SelectInput
                              selectRef={selectInputRef}
                              options={roomList}
                              handleChange={handleSelectRoom}
                              minWidth="md:w-full"
                              label="Select Room"
                            />
                          </div>
                        </div>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"itemName"}
                              label="Item Name"
                              value={values.itemName || ""}
                              placeholder="Smart Apple TV"
                              component={TextField}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"description"}
                              label="Description"
                              value={values.description || ""}
                              placeholder="Smart Apple TV"
                              component={TextField}
                              multiline
                              rows={2}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                        <div className="pt-10">
                          <div className="flex items-center pb-3">
                            <label className="text-xs font-Medium cursor-pointer" htmlFor="imageUpload">
                              Add Photos or Videos
                            </label>
                            <label className="pl-5" htmlFor="imageUpload">
                              <BsFillPlusCircleFill className="text-2xl text-primary cursor-pointer" />
                            </label>
                          </div>
                        </div>
                        <input
                          id="imageUpload"
                          type="file"
                          accept="image/*,video/*"
                          className="w-0.1 h-0.1 overflow-hidden hidden"
                          multiple
                          ref={imageRef}
                          onChange={(event) => {
                            setUploadImage(event.target.files);
                            handleMultipleImages(event);
                          }}
                        />
                        {previews.length > 0 && (
                          <button onClick={() => setPreviews([])} className="text-primary mb-2 self-end">
                            Remove all files
                          </button>
                        )}
                        <div className="flex items-center flex-wrap gap-2">
                          {photos?.map((item, index) => (
                            <div className="pr-5" key={index}>
                              <img src={item.url} alt="" height={100} width={100} />
                            </div>
                          ))}
                          {videos?.map((item, index) => (
                            <div className="relative" key={index}>
                              <video width={"100"} height={"100"} controls>
                                <source src={item.url} alt="" />
                              </video>
                              <div className="absolute top-0 bg-black bg-opacity-30 rounded-lg h-full w-full">
                                <div className="flex justify-center pt-14">
                                  <ImPlay2 className="text-4xl text-white cursor-pointer" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="w-[40%]">
                        <p className="font-medium text-sm pt-6">Add item details which you have in photo</p>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"dateOfPurchase"}
                              label="Date of Purchase"
                              value={values.dateOfPurchase || ""}
                              placeholder="12-Jan-22"
                              component={TextField}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"model"}
                              label="Model"
                              value={values.model || ""}
                              placeholder="Model 2465"
                              component={TextField}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"purchasePrice"}
                              label="Purchase Price"
                              value={values.purchasePrice || ""}
                              placeholder="$3530"
                              component={TextField}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"serialNumber"}
                              label="Serial Number"
                              value={values.serialNumber || ""}
                              placeholder="CN98524366"
                              component={TextField}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                        <div className="pt-6">
                          <div className="mt-1 relative flex">
                            <Field
                              name={"manufacturer"}
                              label="Manufacturer"
                              value={values.manufacturer || ""}
                              placeholder="Apple"
                              component={TextField}
                              className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                  <div className="flex justify-end items-center py-10">
                    <div
                      onClick={handleSubmit}
                      className="flex justify-center items-center py-3 px-7 border-2 border-primary text-primary rounded-md cursor-pointer hover:bg-primary hover:text-white"
                    >
                      <>
                        <FaCloudUploadAlt className="text-2xl" />
                        <p className="text-sm font-medium pl-3">Submit</p>
                      </>{" "}
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default AddContent;
